import React, { useState, useRef, useEffect } from 'react';

const VideoSection: React.FC = () => {
  const videoId = 'QsN5gvjZauk';
  const youtubeChannelUrl = 'https://www.youtube.com/@mintorepair';
  const instagramUrl = 'https://www.instagram.com/minto_repairs/';
  const [showVideo, setShowVideo] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-white rounded-lg border border-gray-100 shadow-sm overflow-hidden mb-6 h-full" ref={sectionRef}>
      <div className="px-4 py-3 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-1 h-5 bg-minto-500 rounded-full" />
          <h3 className="text-base md:text-lg font-semibold text-gray-900">Watch How It Works</h3>
        </div>
      </div>
      <div className="p-4">
        <div className="relative w-full max-w-[400px] mx-auto">
          <div className="video-container" style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
            {!showVideo ? (
              <button
                onClick={() => setShowVideo(true)}
                className="absolute inset-0 w-full h-full bg-gray-900 rounded-xl flex items-center justify-center group cursor-pointer"
                aria-label="Play video"
              >
                {isVisible && (
                  <img
                    src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                    alt="Video thumbnail"
                    className="absolute inset-0 w-full h-full object-cover rounded-xl opacity-80"
                    loading="lazy"
                  />
                )}
                <div className="relative z-10 w-16 h-16 bg-red-600 rounded-full flex items-center justify-center shadow-lg group-hover:bg-red-700 transition-colors">
                  <svg className="w-7 h-7 text-white ml-1" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M8 5v14l11-7z"/>
                  </svg>
                </div>
              </button>
            ) : (
              <iframe 
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                src={`https://www.youtube.com/embed/${videoId}?rel=0&showinfo=0&modestbranding=1&autoplay=1`}
                title="Mobile Repair Service"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                allowFullScreen
                loading="lazy"
                className="rounded-xl"
              ></iframe>
            )}
          </div>
          {/* Video description */}
          <div className="mt-4 text-center">
            <h4 className="text-sm font-medium text-gray-900">Quick Mobile Repair Service</h4>
            <p className="text-xs text-gray-500 mt-1">Watch how we repair your device at your doorstep</p>
            
            {/* Social Media Links */}
            <div className="mt-4 flex gap-3 justify-center">
              <a
                href={youtubeChannelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2 bg-red-600 text-white rounded-full hover:bg-red-700 transition-colors shadow-sm hover:shadow-md"
              >
                <i className="fab fa-youtube text-lg"></i>
                <span className="font-medium">Subscribe</span>
              </a>
              <a
                href={instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-2 bg-gradient-to-r from-purple-500 to-pink-500 text-white rounded-full hover:from-purple-600 hover:to-pink-600 transition-all shadow-sm hover:shadow-md"
              >
                <i className="fab fa-instagram text-lg"></i>
                <span className="font-medium">Follow Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoSection; 